"use client"

import * as React from "react"
import {
  IconCamera,
  IconChartBar,
  IconDashboard,
  IconDatabase,
  IconFileAi,
  IconFileDescription,
  IconFileWord,
  IconFolder,
  IconHelp,
  IconInnerShadowTop,
  IconListDetails,
  IconReport,
  IconRocket,
  IconSearch,
  IconSettings,
  IconSparkles,
  IconUsers,
} from "@tabler/icons-react"


import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar"
import { NavMain } from "./nav.main"
import { NavDocuments } from "./nav.documents"
import { NavSecondary } from "./nav.secondary"
import { NavUser } from "./nave.user"

const data = {
  navMain: [
    {
      title: "Projects",
      url: "#",
      icon: IconFolder,
      children: [
        {
          title: "DayDreaminig",
          url: "/ips",
          icon: IconDashboard,
          children: [
            {
              title: "Alpha 1.0",
              url: "/ips/alpha-1.0",
              icon: IconRocket,
            },
            {
              title: "Beta 2.0",
              url: "/ips/beta-2.0",
              icon: IconSparkles,
            },
          ],
        },
        {
          title: "SnipReel",
          url: "/",
          icon: IconListDetails,
        },
        {
          title: "LitePop",
          url: "/litepop",
          icon: IconChartBar,
        },
      ],
    },
    {
      title: "About Us",
      url: "#",
      icon: IconUsers,
    },
  ],

  navSecondary: [
    {
      title: "Settings",
      url: "#",
      icon: IconSettings,
    },
    {
      title: "Get Help",
      url: "/public/support",
      icon: IconHelp,
    },
    {
      title: "Search",
      url: "#",
      icon: IconSearch,
    },
  ],
  // documents: [
  //   {
  //     name: "Data Library",
  //     url: "#",
  //     icon: IconDatabase,
  //   },
  //   {
  //     name: "Reports",
  //     url: "#",
  //     icon: IconReport,
  //   },
  //   {
  //     name: "Word Assistant",
  //     url: "#",
  //     icon: IconFileWord,
  //   },
  // ],
}

export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
  return (
    <Sidebar collapsible="offcanvas" {...props} className="w-[--sidebar-width] sm:w-88">
      <SidebarHeader>
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton
              asChild
              className="data-[slot=sidebar-menu-button]:p-1.5!"
            >
              <a href="https://www.deepzone.io">
                <IconInnerShadowTop className="size-5!" />
                <span className="text-base font-semibold">DeepZone Limited</span>
              </a>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarHeader>
      <SidebarContent>
        <NavMain items={data.navMain} />
        {/* <NavDocuments items={data.documents} /> */}
        <NavSecondary items={data.navSecondary} className="mt-auto" />
      </SidebarContent>
      <SidebarFooter>
        <NavUser />
      </SidebarFooter>
    </Sidebar>
  )
}
